import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d3286d0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "custom-toast-body cow-toast-danger" }
const _hoisted_3 = { class: "me-auto" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close me-1",
  "data-bs-dismiss": "toast",
  "aria-label": "Close"
}, null, -1 /* HOISTED */))

import { onMounted } from 'vue';
import Toast from 'bootstrap/js/dist/toast';
import { useUid } from '@app/composables/useUid';


export default /*#__PURE__*/_defineComponent({
  __name: 'errorMessageToast',
  props: {
    message: {}
  },
  setup(__props: any) {



const uid = useUid();

onMounted(() => {
  const toast = document.getElementById(`toast-${uid}`);
  if (toast) {
    // eslint-disable-next-line no-new
    new Toast(toast).show();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: `toast-${_unref(uid)}`,
    class: "toast fade m-auto mb-1 mb-md-3 ms-md-auto me-md-3",
    role: "status",
    "aria-live": "polite",
    "aria-atomic": "true",
    "data-bs-delay": "30000"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("strong", _hoisted_3, _toDisplayString(_ctx.message), 1 /* TEXT */),
      _hoisted_4
    ])
  ], 8 /* PROPS */, _hoisted_1))
}
}

})